// Librairies
import Dexie from 'dexie';

// Une base par utilisateur : « grality-offline-<userId> »
export const OFFLINE_DB_PREFIX = 'grality-offline-';

export const createOfflineDb = (name) => {
    const db = new Dexie(name);
    // Ne jamais modifier une version déjà livrée : en ajouter une nouvelle, avec sa migration
    db.version(1).stores({
        meta: 'key',                                                           // { key, value } : données de démarrage, réglages
        projects: 'id, lastOpenedAt',                                          // copie d'un projet (objet projet, droits, chargement des arbres…)
        elements: '[projectId+id], projectId, [projectId+category]',           // { projectId, id, category, server, local, removed, loadId, savedAt }
        treeChunks: '[projectId+loadId+order], [projectId+loadId], projectId', // blocs binaires des arbres, tels que reçus de l'API
        lists: '[projectId+name], projectId',                                  // { projectId, name, data, savedAt }
        photos: 'id, projectId',                                               // photos compressées en attente d'envoi
        outbox: '++seq, &id, status, targetKey, *touches',                     // opérations à envoyer
        idMap: '[entity+localId]',                                             // { entity, localId, serverId }
        syncLog: '++id'                                                        // journal de l'écran Synchronisation (saisies écartées, abandons…)
    });
    return db;
};
